import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import "./BottomButtons.css";

export default function MapLegendButton() {

    const { t } = useTranslation(["nbhd", "assessment"]);

    const [showLegend, toggleLegend] = useState(false);

    const hideShowLegend = () => {
        toggleLegend(!showLegend);
    }

    return <>
        {showLegend && (
            <div id='map_legend' className='legend'>
                <p><h4>{t("nbhd.legend.title")}</h4></p>
                <p><div><span style={{ 'backgroundColor': '#ffffcc' }}></span>{t("nbhd.legend.res")}</div></p>
                <p><div><span style={{ 'backgroundColor': '#c4bd97' }}></span>{t("nbhd.legend.mul")}</div></p>
                <p><div><span style={{ 'backgroundColor': '#ccc0da' }}></span>{t("nbhd.legend.com")}</div></p>
                <p><div><span style={{ 'backgroundColor': '#a6bfef' }}></span>{t("nbhd.legend.ind")}</div></p>
                <p><div><span style={{ 'backgroundColor': '#92d050' }}></span>{t("nbhd.legend.frm")}</div></p>
                <p><div><span style={{ 'backgroundColor': '#b7dee8' }}></span>{t("nbhd.legend.spe")}</div></p>
            </div>
        )}
        <div id='legend' className={`legend_btn ${showLegend ? "dark-active" : ""}` } onClick={() => hideShowLegend()} >
            {t("nbhd.legend.title")}
        </div>
    </>;
}
